<template>
  <ModalEdit :id="modalId" :title="$t('text.addNote')" :loading="isLoading" @click="onSubmit">
    <div class="p-5" style="color: #000;">
      <InputString
        isTextarea
        v-model.trim="$v.form.description.$model"
        :vuelidate="$v.form.description"
        :label="$t('text.description')"
      />
      <template v-if="loanId">
        <InputDate v-model="form.reminderDate" :label="$t('text.reminderDate')" />
      </template>
    </div>
  </ModalEdit>
</template>

<script>
import { mapGetters } from 'vuex';
import { assign } from 'lodash';
import { NOTE_ADD } from '@/store/actions/note';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import ModalEdit from '@/components/ui/ModalEdit';
import baseModalMixin from '@/mixins/baseModalMixin';
import InputDate from '@/components/ui/input/InputDate';
import InputString from '@/components/ui/input/InputString';

export default {
  mixins: [validationMixin, baseModalMixin],

  components: {
    ModalEdit,
    InputDate,
    InputString,
  },

  props: {
    loanId: Number,
    customerId: Number,
  },

  validations() {
    return {
      form: {
        description: {
          required,
        },
      },
    };
  },

  data() {
    return {
      form: {
        reminderDate: '',
        description: '',
      },
    };
  },

  computed: {
    ...mapGetters(['noteStatus']),
    isLoading() {
      return this.noteStatus === 'loading';
    },
  },

  methods: {
    resetForm() {
      this.form = {
        reminderDate: '',
        description: '',
      };
      this.$v.$reset();
    },
    async onSubmit() {
      if (this.$v) {
        this.$v.form.$touch();
        if (this.$v.form.$anyError) {
          this.$toasted.show(this.$t('toast.failedForm'), { type: 'error' });
          return;
        }
      }

      const payload = {
        ...this.form,
      };

      if (this.loanId) {
        assign(payload, { loanId: this.loanId });
      } else {
        assign(payload, { userId: this.customerId });
      }

      await this.$store.dispatch(NOTE_ADD, payload);

      if (this.noteStatus === 'success') {
        this.$toasted.show(this.$t('toast.success'), { type: 'success' });
        this.hideEditModal();
        this.resetForm();
      }
    },
  },
};
</script>
